var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Modal, withAnalytics, withMountTracking, compose } from "@atlassiansox/microscopekit";
import styled from "styled-components";
import { Artifacts } from "./ArtifactsView";
var ArtifactSpan = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"], ["\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"])));
var ArtifactModal = /** @class */ (function (_super) {
    __extends(ArtifactModal, _super);
    function ArtifactModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
        };
        _this.pageSize = 10;
        return _this;
    }
    ArtifactModal.prototype.artifactRow = function (artifact, truncateName, truncateDigest) {
        var _this = this;
        return React.createElement(ArtifactSpan, { onClick: function () {
                _this.setState({ isOpen: true });
                _this.props.track("Artifact modal opened", { category: 'info', id: _this.props.id });
            } },
            React.createElement("b", null, this.artifactName(truncateName)),
            "@",
            this.artifactVersion(truncateDigest));
    };
    ArtifactModal.prototype.artifactName = function (truncate) {
        var repo = this.props.artifact.name.replace(/_/g, "/");
        var truncatedRepo = repo.replace("docker.atl-paas.net/", "");
        return truncate ? truncatedRepo : repo;
    };
    ArtifactModal.prototype.artifactVersion = function (truncate) {
        return this.props.artifact.reference.split(":")[1].substr(0, 8) + "...";
    };
    ArtifactModal.prototype.render = function () {
        var _this = this;
        return (React.createElement("p", null,
            React.createElement(Modal, { isOpen: this.state.isOpen, heading: this.artifactName(true) + "@" + this.artifactVersion(true), width: "large", actions: [
                    {
                        text: "Close",
                        onClick: function () { return new Promise(function (resolve) { return _this.setState({ isOpen: false }, resolve); }); }
                    },
                ], onClose: function () { return _this.setState({ isOpen: false }); } },
                React.createElement("p", null, this.props.artifact.reference),
                React.createElement("h4", { style: { marginBottom: "10px" } }, "This artifact is currently deployed in:"),
                React.createElement(Artifacts, __assign({}, {
                    name: this.props.artifact.name,
                    version: this.props.artifact.version,
                    page: 0,
                    pageSize: this.pageSize,
                }))),
            this.artifactRow(this.props.artifact, true, false)));
    };
    return ArtifactModal;
}(React.Component));
export { ArtifactModal };
export var ArtifactModalComponent = compose(withMountTracking("ArtifactModal"), withAnalytics)(ArtifactModal);
var templateObject_1;
